import React from "react";
import { useTranslation } from "react-i18next";
import MerchantStepButtons from "../MerchantStepButtons";
import { useNavigate } from "react-router-dom";

export const Step3EmailVerifiedSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="w-full h-full flex flex-col justify-between">
      <div className="flex flex-col items-center text-center">
        <h2 className="text-xl md:text-2xl font-bold text-black dark:text-white mt-[166.5px] mb-[30px] font-nunito">
          {t("merchantRegister.step3.title")}
        </h2>

        <p className="text-[#75757D] dark:text-gray-400 text-sm md:text-base font-nunito px-2">
          {t("merchantRegister.step3.description")}
        </p>

        <p className="text-[#75757D] dark:text-gray-400 text-sm md:text-base font-nunito px-2">
          {t("merchantRegister.step3.instruction")}
        </p>
      </div>

      <div className="flex-1 flex items-end justify-end">
        <MerchantStepButtons
          previousBtn={{
            label: t("merchantRegister.buttons.back"),
            onClick: () => navigate("/merchant/register/verify-email"),
          }}
          nextBtn={{
            label: t("merchantRegister.buttons.next"),
            onClick: () => navigate("/merchant/register/business-details"),
          }}
        />
      </div>
    </div>
  );
};

export default Step3EmailVerifiedSuccess;
